module.exports = __webpack_public_path__ + "img/专利质押件数.372880ec.png";